import classNames from 'classnames';
import React from 'react';
import { Input } from '@wg/wows-react-uikit';

import settings from '~/settings';
import { t } from '~/helpers/localization';

import styles from './ClanCreate.scss';

import type { Nullable } from '~/types/generics';

type IProps = {
  className?: string;
  value: string;
  error?: Nullable<string>;
  isDisabled?: boolean;
  isValidating?: boolean;
  isFocusOn?: boolean;
  onChange: (value: string, error: Nullable<string>) => void;
};

const ClanTagInput: React.FC<IProps> = (props) => {
  const value = props.value;
  const onChange = props.onChange;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const eventValue = event.target.value.toUpperCase();
    if (eventValue === value) {
      return;
    }

    let error: Nullable<string> = null;
    const TAG_REG_EXP = new RegExp(settings.clanCreate.tagPattern);
    const clanTag = eventValue.trim();

    if (clanTag.length === 0) {
      error = t('Введите тег клана');
    } else if (clanTag.trim().length < settings.clanCreate.tagMinLength) {
      error = t('Минимальное количество символов: %(minLength)s', {
        minLength: settings.clanCreate.tagMinLength,
      });
    } else if (!TAG_REG_EXP.test(eventValue)) {
      error = t('Содержит недопустимые символы.');
    } else if (eventValue.length > settings.clanCreate.tagMaxLength) {
      error = t('Максимальное количество символов: %(maxLength)s', {
        maxLength: settings.clanCreate.tagMaxLength,
      });
    }

    onChange(eventValue, error);
  };

  return (
    <Input
      noimesupport
      label={t('Тeг')}
      className={classNames(styles.inputContainer, props.className)}
      classNames={{
        label: styles.label,
        info: styles.info,
      }}
      value={value}
      width="110px"
      maxLength={settings.clanCreate.tagMaxLength}
      error={props.error || undefined}
      info={t(
        'Сокращённое название клана (от 2 до 5 символов: цифр, латинских букв, «_» или «-»), которое вы будете видеть в игре.',
      )}
      isDisabled={props.isDisabled}
      isValidating={props.isValidating}
      isFocusOn={props.isFocusOn}
      onChange={handleChange}
    />
  );
};

export default React.memo(ClanTagInput);
